import {
  ICreateOccurrence,
  IFilteredOccurrences,
  IOccurrence,
  IUpdateOccurrence,
} from "interfaces/Occurrence";
import { ISuperficialIVehicleProps } from "interfaces/Vehicle";
import {
  createOccurrenceService,
  deleteOccurrence,
  createSuperficialVehicleService,
  GroupByStatus,
  updateOccurrenceService,
  updateSuperficialVehicleService,
  cancelOccurrence,
} from "../OccurrenceService";
export interface IDeleteOccRegisterProps {
  occurrence?: IOccurrence;
  id?: string;
}

export interface ICancelOccurrenceProps extends IDeleteOccRegisterProps {
  occurrence?: IOccurrence;
  reportId: string;
}

export function filteredOccurrenceHandle(
  occurrences: IOccurrence[]
): IFilteredOccurrences {
  const filteredByStatus = GroupByStatus(occurrences);

  let waitingList: IOccurrence[] | undefined = [];
  if (filteredByStatus.aprovacao)
    waitingList.push(...filteredByStatus.aprovacao);
  if (filteredByStatus["aprovacao-km-inicial"])
    waitingList.push(...filteredByStatus["aprovacao-km-inicial"]);
  if (filteredByStatus["aprovacao-km-final"])
    waitingList.push(...filteredByStatus["aprovacao-km-final"]);

  return {
    all: occurrences,
    inProgress: filteredByStatus.andamento || [],
    finished: filteredByStatus.concluido || [],
    waiting: waitingList || [],
  };
}

export function orderOccurrenceByDateHandle(arg: IOccurrence[], order: string) {
  if (order === "-1") {
    const myData = ([] as IOccurrence[])
      .concat(arg)
      .sort(function (a, b) {
        if (a.createdAt > b.createdAt) {
          return -1;
        }
        if (a.createdAt < b.createdAt) {
          return 1;
        }
        return 0;
      })
      .map((element) => {
        return element;
      });
    return myData;
  }
  if (order === "1") {
    const myData = ([] as IOccurrence[])
      .concat(arg)
      .sort(function (a, b) {
        if (a.createdAt > b.createdAt) {
          return 1;
        }
        if (a.createdAt < b.createdAt) {
          return -1;
        }
        return 0;
      })
      .map((element) => {
        return element;
      });
    return myData;
  }
  return arg;
}

export function handleOccurrenceDeleteSubmit({
  occurrence,
  id
}: IDeleteOccRegisterProps) {
  deleteOccurrence({ occurrence, id })
    .then((res) => {
      localStorage.setItem("message", "Ocorrencia cancelada com sucesso");
      window.location.reload();
    })
    .catch((err) => {
      console.log(err.response);
    });
}

export function handleOccurrenceCancelSubmit({
  occurrence,
  reportId
}: ICancelOccurrenceProps) {
  cancelOccurrence({ occurrence, reportId })
    .then((res) => {
      localStorage.setItem("message", "Ocorrencia cancelada com sucesso");
    })
    .catch((err) => {
      console.log(err.response);
    })
}

export async function handleOccurrenceSubmit({
  lastCoords,
  patrimonialType,
  postalCode,
  street,
  number,
  district,
  uf,
  city,
  coordX,
  coordY,
  numberBO,
  superficialClient,
  lastCoordX,
  lastCoordY,
  reference,
  isManual,
  workType,
  superficialVehicle,
  superficialAddressId,
  Client,
  superficialClientId,
  policemen
}: ICreateOccurrence) {
  return await createOccurrenceService({
    lastCoords,
    patrimonialType,
    postalCode,
    street,
    number,
    district,
    uf,
    city,
    coordX,
    coordY,
    numberBO,
    superficialClient,
    lastCoordX,
    lastCoordY,
    reference,
    workType,
    superficialVehicle,
    isManual,
    superficialAddressId,
    Client,
    superficialClientId,
    policemen: (policemen && policemen?.length > 0) ? policemen : undefined
  })
    .then((res) => {
      if (res.data.status === true) {
        localStorage.setItem(
          "message",
          "Os dados da ocorrência foram cadastrados corretamente."
        );
      }
      return res;
    })
    .catch((err) => {
      console.log(err.response);
      return err.response;
    });
}

export async function handleOccurrenceUpdate({
  id,
  lastCoords,
  patrimonialType,
  status,
  superficialClient,
  numberBO,
  lastCoordX,
  lastCoordY,
  postalCode,
  street,
  number,
  district,
  uf,
  city,
  reference,
  complement,
  coordX,
  coordY,
  superficialAddressId,
  workType,
  superficialVehicle,
}: IUpdateOccurrence) {
  return await updateOccurrenceService({
    id,
    lastCoords,
    patrimonialType,
    status,
    superficialClient,
    numberBO,
    lastCoordX,
    lastCoordY,
    postalCode,
    street,
    number,
    district,
    uf,
    city,
    reference,
    complement,
    coordX,
    coordY,
    superficialAddressId,
    workType,
    superficialVehicle,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err.response);
      return err.response;
    });
}

export async function handleOccurrenceVehicleUpdate({
  brand,
  color,
  description,
  model,
  plate,
  id,
  occurrence,
  type,
  superficialClient,
}: ISuperficialIVehicleProps) {
  return await updateSuperficialVehicleService({
    id,
    brand,
    color,
    description,
    model,
    plate,
    occurrence,
    type,
    superficialClient,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err.response);
      return err.response;
    });
}

export async function handleOccurrenceVehicleCreate({
  brand,
  color,
  description,
  model,
  plate,
  superficialClient,
  occurrence,
  type
}: ISuperficialIVehicleProps) {
  return await createSuperficialVehicleService({
    brand,
    color,
    description,
    model,
    plate,
    occurrence,
    superficialClient,
    type
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err.response);
      return err.response;
    });
}
